export const QuestionTypes = {
    "TEXT_SIMPLE": 1,
    "TEXT_MULTI": 2,
    "SELECTION_MULTI": 3,
    "SELECTION_SINGLE": 4, 
    "SCALE_5_STARS": 5,
    "DATE": 6,
    "COMBOBOX": 7,
    "NUMBER": 8,
    "SCALE_3_FACES": 9,
    "SCALE_7_NUMERIC_W_RADIO": 10,
    "SCALE_7_NUMERIC_WO_RADIO": 11,
    "SCALE_5_FACES": 12,
    "TOTAL_SATISFACTION": null,
    "SCALE_NUMERIC_0_TO_10": 14,
    "CHECKLIST": null,
    "PHOTO": 16,
    "NATIONAL_SCALE": 17,
    "RANKING": 18,
    "SCALE_0_TO_10_STARS": 19,
    "SCALE_1_TO_10_STARS": 20,
    "NPS_WITH_RADIO": 21,   
    "SELECTION_WITH_IMAGES": null, // single/multi selection type question with images on it
    "NPS": 23,
    "TERMS_AND_CONDITIONS": 24,
    "MAXDIFF": 25,
    "MAXDIFF_ATTR": null, 
    "YES_NO": 27,
    "ISTAS_21": 28,
    "LIKERT": 29,
    "FILE": 30,
    "AUDIO": null, // currently unavailable
    "SCALE_NUMERIC_1_TO_5": 32,
    "HTML": 33, 
    "MATRIX": 100,
}

export const QuestionTypeGroups = {
    1: "TEXT",
    2: "TEXT",
    3: "MULTI_SELECTION",
    4: "SINGLE_SELECTION",
    5: "SINGLE_SELECTION",
    6: "DATE",
    7: "SINGLE_SELECTION",
    8: "TEXT",
    9: "SINGLE_SELECTION",
    10: "SINGLE_SELECTION",
    11: "SINGLE_SELECTION",
    12: "SINGLE_SELECTION",
    13: "SINGLE_SELECTION",
    14: "SINGLE_SELECTION",
    15: "MULTI_SELECTION",
    16: "FILE",
    17: "SINGLE_SELECTION",
    18: "RANKING",
    19: "SINGLE_SELECTION",
    20: "SINGLE_SELECTION",
    21: "SINGLE_SELECTION",
    22: "MULTI_SELECTION",
    23: "SINGLE_SELECTION",
    24: "BOOLEAN",
    25: "MAX_DIFF",
    26: null,
    27: "SINGLE_SELECTION",
    28: null,
    29: "SINGLE_SELECTION",
    30: "FILE",
    31: "FILE",
    32: "SINGLE_SELECTION",
    33: null,
    35: "CONJOINT",
    100: "MATRIX"
}

export const MatrixScaleConvertion = {
    1: 5,
    2: 10,
    3: 14,
    4: 17,
    5: null,
    6: 9,
    7: 12,
    8: null,
    9: 4,
}

export const MatrixType = {
    "MATRIX_SINGLE"     : 1,
    "MATRIX_MULTIPLE"   : 2
}
